// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-tail_root__0XwKj"};